import { FormEnginePlugin } from '@form-engine/core-application';
import { SourceType } from '@form-engine/datasource-static/datasources/static-datasource';
import { apiName } from './datasources/http-request';
import Datasource from './datasources/http-request/client';

declare module '@form-engine/core-application/types/form' {
    interface DatasourceDefinitionSubType {
        [apiName]: {
            url?: string;
            method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
            sourceType?: SourceType;
            labelColumn?: string;
            valueColumn?: string;
            body?: string;
            contentType?: string;
        } & AuthInfo;
    }
}

export default {
    datasources: {
        [apiName]: Datasource,
    },
} as FormEnginePlugin;
